// 收益类型
export const cashIntoTypeEnum = {
  ZB_SITE: 0, // 直播间收益
  PERSONAL: 1 // 个人收益
}

export const drawOrderTypeEnum = {
  WITHDRAWAL_AMOUNT: 0, // 提现金额
  PROGRAMME_EXPEND: 1, // 导播台支出
  COMMISSION: 2 // 佣金自动到账
}

// 直播间收益状态
export const billStatusEnum = {
  SETTLED: 0, // 已结算
  PENDING: 1, // 待结算
  SERVICER_PENDING: 2, // 分账待结算
  REFUNDED: -1, // 待结算后退款成功
  REFUND_BY_SETTLED: -2 // 结算后退款成功
}

// 支付方式
export const payTypeEnum = {
  WECHAT: 0, // 微信
  LIVE_ROOM_BALANCE: 1, // 直播间余额
  NOT_DEDUCT: 2, // 不扣费-核销红包
  THIRD_PARTY: 3 // 第三方-连连支付
}

// 提现明细状态
export const withdrawalStatusEnum = {
  AGAIN: -2, // 重新提现
  FAIL: -1, // 失败
  NONE: 0, // 未处理
  SUCCESS: 1 // 成功
}

export const zbSiteIncomeTypeOptions = [
  {
    value: '',
    text: '全部'
  },
  {
    value: '19',
    text: '话题'
  },
  {
    value: '23',
    text: '频道'
  },
  {
    value: '13',
    text: '打赏'
  },
  {
    value: '18',
    text: '直播间VIP'
  },
  {
    value: '28',
    text: '转播'
  },
  // {
  //   value: "27",
  //   text: "私问"
  // },
  {
    value: '26',
    text: '赠礼'
  },
  {
    value: '200',
    text: '电商'
  },
  {
    value: '44',
    text: '投票礼物'
  },
  {
    value: '220',
    text: '话题拼团'
  },
  {
    value: '221',
    text: '频道拼团'
  },
  {
    value: '297',
    text: '核销优惠券'
  }
]

export const personalIncomeTypeOptions = [
  {
    value: '',
    text: '全部'
  },
  {
    value: '21',
    text: '红包'
  },
  {
    value: '13',
    text: '打赏'
  },
  {
    value: '22',
    text: '礼物'
  },
  {
    value: '33',
    text: '分销'
  },
  {
    value: '-1',
    text: '其他'
  }
]
